export const SubtitleTemplate = ({ children, className }) => {
    return (
        <h2 className={`text-md ${className}`}>
            {children}
        </h2>
    )
}